import SwimlaneCollection from './SwimlaneCollection';

export default SwimlaneCollection;
